import { Bar } from "react-chartjs-2";
import { Fragment, useEffect, useState } from "react";
import { Child, Container, Header, LayerContent } from "../style";
import { TableContainer } from "../../../Users/User.style";
import { ChartContainer, NoData } from "../../style";
import { useAnalyticsWrapper } from "../../../../../store/store";
import useAnalytics from "../../../../../hooks/useAnalytics";
import moment from "moment";
import {
  barOptions,
  getMetrics,
  doTransformData,
  woundIncidentUnitPlaceCols,
  handlePointClicked,
  transformDataForBarChart,
  prepareTableData,
  prepareChartData
} from "../formUtils";
import CustomerLoader from "../../../../../components/CustomLoader";
import SectionModal, { DefaultContainer } from "./SectionModal";
import {
  handleCSVDownload,
  handlePDFDownload,
} from "../../../../../utils/helpers/pdfCsvUtils";
import { woundAnalysisDetailCols } from "../../dummyData/colums";
import { Grid, GridColumn, GridColumnProps } from '@progress/kendo-react-grid';
import { CenteredWholeNumCell, HeaderCenteredCell } from "../../../../../components/DynamicGrid/customCells";
import { TotalRow } from "../../../../../components/DynamicGrid/customRows";
import { set } from "lodash";

const RepeatSkinIncidents = ({
  setClickedIncident,
  isFetchingSelectedIncident,   
}: any) => {
  const [tableData, setTableData] = useState<any>([]);
  const [grid, setGrid] = useState<any>([]);    
  const [barData, setBarData] = useState<any>([]);
  const [resident, setResident] = useState("");
  const [showResidentModal, setShowResidentModal] = useState(false);
  const [areaDetails, setAreaDetails] = useState<any>([]);

  const { startDate, endDate, woundFacility, woundAnalysisIncidents } = useAnalyticsWrapper((state) => ({
    startDate: state.startDate,
    endDate: state.endDate,
    woundFacility: state.woundFacility,
    woundAnalysisIncidents: state.woundAnalysisIncidents
  }));

  type RepeatRow = {
    residentName: string;
    percentage: number;
    count: number;
  };

  const adjustedTableData = (areaData: any) => {
    let returnData: RepeatRow[] = [];
    if (areaData.length) {
      let countTotal = 0;
      let percentageTotal = 0;
      for (let i = 0; i < areaData.length; i++) {

        const row: RepeatRow = {
          residentName: areaData[i].residentName,
          percentage: areaData[i].percentage,
          count: areaData[i].incidentCount,
        };
        returnData.push(row);
        countTotal += areaData[i].incidentCount;
        percentageTotal += areaData[i].percentage;
      }
      const totalRow: RepeatRow = {
        residentName: "Total",
        percentage: percentageTotal,
        count: countTotal,
      };
      returnData.push(totalRow);
    }
    return returnData;
  }

  useEffect(() => {
    if (woundAnalysisIncidents !== undefined) {
      const tempData = woundAnalysisIncidents?.repeatSkinIncidents.residentBreakdown;
      const transformedData = adjustedTableData(tempData);
      const transformedBarData = transformDataForBarChart(
        transformedData,
        "residentName"
      );   
      setTableData(transformedData);
      setBarData(transformedBarData);
      setAreaDetails(woundAnalysisIncidents?.allIncidents);
    }
  }, [woundAnalysisIncidents]);
  
  const title = "Repeat Skin Incidents";

  const handleBarClicked = (chart: any) => {
    if (!chart.length) return;
    const label = handlePointClicked(chart, barData?.labels);
    setShowResidentModal(true);
    setResident(label);
    const filteredDetails = woundAnalysisIncidents.repeatSkinIncidents.drillDownByResident[label] || [];
    setAreaDetails(filteredDetails);
  };

  useEffect(() => {
    let cellCountProps = { cells: { data: CenteredWholeNumCell, headerCell: HeaderCenteredCell } };
    let cellPercentageProps = { cells: { data: CenteredWholeNumCell, append: '%', headerCell: HeaderCenteredCell } };
    const grid = (
      <Fragment>
        <Grid
          data={tableData || []}
          scrollable="none"
          rows={{ data: TotalRow }}
      >
        <GridColumn field="residentName" title="Resident Name" />
        <GridColumn field="count" title="# of Incidents" {...cellCountProps as GridColumnProps}/>
        <GridColumn field="percentage" title="%" {...cellPercentageProps as GridColumnProps}/>
        </Grid>
      </Fragment>
    );
    setGrid(grid);
  }, [tableData]); 

   return (
    <LayerContent>
      <Header>{title}</Header>
        <Container>
          <Child flex="40%">
            {grid}
          </Child>
          <Child flex="60%">
            <ChartContainer>
              {barData?.labels?.length > 0 ? (
                <Bar options={barOptions(handleBarClicked)} data={barData} />
              ) : (
                <NoData>No Data</NoData>
              )}
            </ChartContainer>
          </Child>
        </Container>
      {showResidentModal ? (
        <SectionModal
          open={showResidentModal}
          facilityName={(woundFacility?.label ?? woundFacility?.[0]?.label)}
          startDate={startDate}
          endDate={endDate}
          closeFn={() => setShowResidentModal(false)}
          resetFn={() => {}}
          isLoading={false}
          tableData={areaDetails}
          tableCols={woundAnalysisDetailCols()}
          title={`${title} - ${resident}`}
          getUserCallback={(item: any) => setClickedIncident(item)}
          handlePdfExport={() =>
            handlePDFDownload({
              data: areaDetails,
              columnData: woundAnalysisDetailCols(),
              fileName: (woundFacility?.label ?? woundFacility?.[0]?.label),
              startDate,
              endDate,
              subTitle: `${title} - ${resident}`,
            })
          }
          handleCsvExport={() =>
            handleCSVDownload(
              areaDetails,
              woundAnalysisDetailCols(),
              `${(woundFacility?.label ?? woundFacility?.[0]?.label)} - ${title} - ${resident}`
            )
          }
        />
      ) : null}
    </LayerContent>
  );
};

export default RepeatSkinIncidents;